export function isVisualModelSerializationV1(what) {
    return what.type === "http://dataspecer.com/resources/local/visual-model"
        && what.version === 1;
}
export function visualModelSerializationV1ToV2(serialization) {
    return {
        ...serialization,
        version: 2,
        // We just need to move "identifier" to "id".
        entities: serialization.entities.map(entity => {
            const next = { ...entity };
            next.id = entity.identifier;
            delete next["identifier"];
            return next;
        }),
    };
}
//# sourceMappingURL=serialization-v1-to-v2.js.map